import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import styles from './button.module.css';

const Button = ({variant, onClick, disabled, children, className}) => {

  const classNames = clsx({
    [styles.default]: true,
    [styles[variant]]: true,
    [styles.disabled]: disabled,
    [className]: className
  });

  return (
    <button
      className={classNames}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

Button.propTypes = {
  variant: PropTypes.oneOf(['primary', 'secondary', 'border']),
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string
};

Button.defaultProps = {
  variant: 'primary',
  disabled: false,
  children: '',
  className: ''
};

export {Button};
